angular.module('bmsApp.global').controller('ChangeLogModalCtrl',
    function ($scope,
              $q,
              $timeout,
              $modalInstance,
              ChangeLogSvc,
              InstanceSvc) {

        $scope.cancel = function () {
            $modalInstance.close(true);
        };

        var params = {
            count: 5,
            filter: {
                recent: ''
            }
        };

        ChangeLogSvc.index(params).then(function (response) {
            $scope.versions = response.data.version_collection;
        });

        $scope.forNetwork = function(logItem) {
            var type;
            if (InstanceSvc.instance.isMM()) {
                type = 'mm';
            }
            else if (InstanceSvc.instance.isTG()) {
                type = 'tg';
            }
            else if (InstanceSvc.instance.isSM()) {
                type = 'sm';
            }
            return (logItem.network === '' || logItem.network === type);
        }
    });
